const MPH_TO_KMH = 1.60934;
const MI_TO_KM = 1.60934;
const FT_TO_M = 0.3048;

export function isMetric(user) {
  return user?.units === 'metric';
}

export function convertSpeed(mph, user) {
  if (mph == null) return null;
  return isMetric(user) ? mph * MPH_TO_KMH : mph;
}

export function convertDistance(miles, user) {
  if (miles == null) return null;
  return isMetric(user) ? miles * MI_TO_KM : miles;
}

export function speedUnit(user) {
  return isMetric(user) ? 'km/h' : 'MPH';
}

export function distanceUnit(user) {
  return isMetric(user) ? 'km' : 'mi';
}

export function formatSpeed(value, user) {
  if (value == null) return '--';
  const converted = convertSpeed(value, user);
  return Math.round(converted) + ' ' + speedUnit(user);
}

export function convertFeet(feet, user) {
  if (feet == null) return null;
  return isMetric(user) ? feet * FT_TO_M : feet;
}

export function feetUnit(user) {
  return isMetric(user) ? 'm' : 'ft';
}

export function formatFeet(value, user) {
  if (value == null || !Number.isFinite(value)) return '--';
  const converted = convertFeet(value, user);
  return `${Math.round(converted)} ${feetUnit(user)}`;
}

export function formatDistance(value, user) {
  if (value == null) return '--';
  const converted = convertDistance(value, user);
  return converted.toFixed(2) + ' ' + distanceUnit(user);
}
